"use strict";
angular.module('cloudRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state("front.cloud", {
            url: '/cloud',
            views: {
                'main@front': {
                    templateUrl: './cloud/index_tpl.html',
                },
                'main@front.cloud': {
                    templateUrl: './cloud/main_tpl.html',
                    controller: 'cloudController'
                }
            }
        });
    }]);